
    import { initBackgroundScene } from '/src/scripts/bgScene.js';
    import { initHeroScroll, initContinuousScrollKinetics } from '/src/scripts/heroScroll.js';
    import { initVideoLazyLoad } from '/src/scripts/videoLazyLoad.js';
    import { initInteractions } from '/src/scripts/interactions.js';
    import { initModal } from '/src/scripts/modal.js';

    // Cloudflare Turnstile Configuration (Auto-rendered via cf-turnstile class)
    window.onloadTurnstileCallback = function () {
      console.log('Turnstile loaded');
    };

    document.addEventListener('DOMContentLoaded', () => {
      initBackgroundScene();
      initHeroScroll();
      initContinuousScrollKinetics();
      initVideoLazyLoad();
      initInteractions();
      initModal();

      // Mobile Drawer Toggle
      const toggleBtn = document.getElementById('mobile-menu-toggle');
      const closeBtn = document.getElementById('mobile-drawer-close');
      const drawer = document.getElementById('mobile-nav-drawer');
      const overlay = document.getElementById('drawer-overlay');
      const drawerLinks = document.querySelectorAll('.drawer-link, .drawer-btn');

      function toggleDrawer() {
        const isOpen = drawer?.classList.toggle('is-open');
        overlay?.classList.toggle('is-active', isOpen);
        toggleBtn?.classList.toggle('is-active', isOpen);
        document.body.style.overflow = isOpen ? 'hidden' : '';
      }

      function closeDrawer() {
        drawer?.classList.remove('is-open');
        overlay?.classList.remove('is-active');
        toggleBtn?.classList.remove('is-active');
        document.body.style.overflow = '';
      }

      toggleBtn?.addEventListener('click', toggleDrawer);
      overlay?.addEventListener('click', closeDrawer);
      closeBtn?.addEventListener('click', closeDrawer);
      drawerLinks.forEach((link) => link.addEventListener('click', closeDrawer));

      // Toolkit Expand/Collapse Toggle
      const toolkitToggleBtn = document.getElementById('toggle-toolkit-btn');
      const toolkitDrawer = document.getElementById('full-toolkit-drawer');
      const toolkitToggleText = document.getElementById('toggle-toolkit-text');

      if (toolkitToggleBtn && toolkitDrawer) {
        toolkitToggleBtn.addEventListener('click', () => {
          const isOpen = toolkitDrawer.classList.toggle('is-open');
          toolkitToggleText.innerHTML = isOpen ? 'Hide full toolkit &uarr;' : 'See full toolkit &rarr;';
        });
      }

      const form = document.getElementById('falcon-contact-form');
      const status = document.getElementById('form-status');
      const submitBtn = form ? form.querySelector('button[type="submit"]') : null;

      if (form && submitBtn) {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          status.style.display = 'block';
          status.style.padding = '0.85rem 1.2rem';
          status.style.borderRadius = '4px';
          status.style.fontWeight = '700';
          status.style.letterSpacing = '0.05em';
          status.style.color = 'var(--f-amber)';
          status.style.background = 'rgba(248, 146, 15, 0.08)';
          status.style.border = '1.5px solid var(--f-amber)';
          status.textContent = 'TRANSMITTING DOSSIER...';
          
          const originalBtnText = submitBtn.innerHTML;
          submitBtn.innerHTML = '<span>TRANSMITTING DOSSIER...</span>';
          submitBtn.disabled = true;

          const formData = new FormData(form);
          const tToken = formData.get('cf-turnstile-response') || (window.turnstile ? window.turnstile.getResponse() : '');
          
          if (!tToken) {
            status.style.display = 'block';
            status.style.padding = '0.85rem 1.2rem';
            status.style.borderRadius = '4px';
            status.style.fontWeight = '700';
            status.style.letterSpacing = '0.05em';
            status.style.color = 'var(--f-terracotta)';
            status.style.background = 'rgba(224, 90, 71, 0.08)';
            status.style.border = '1.5px solid var(--f-terracotta)';
            status.textContent = 'TRANSMISSION FAILED: Please complete the security check before submitting.';
            
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalBtnText;
            return;
          }

          const payload = {
            name: formData.get('name') || '',
            contact: formData.get('contact') || '',
            systemType: formData.get('project_type') || '',
            message: formData.get('message') || '',
            turnstileToken: tToken
          };

          console.log("Submitting lead payload with token:", payload.turnstileToken);

          try {
            // Dynamically import the telegram helper
            const { sendTelegramAlert } = await import('/src/scripts/telegram.js');
            await sendTelegramAlert('INTAKE', payload);

            status.style.color = '#10b981';
            status.style.background = 'rgba(16, 185, 129, 0.08)';
            status.style.border = '1.5px solid #10b981';
            status.textContent = '✓ TRANSMISSION CONFIRMED. INTAKE DOSSIER QUEUED.';
            form.reset();
            
            // Reset Turnstile
            if (window.turnstile) {
              try { window.turnstile.reset(); } catch(e) {}
            }
            
            submitBtn.classList.add('is-success');
            submitBtn.innerHTML = '<span>[ ✓ DOSSIER TRANSMITTED ]</span>';
            
            setTimeout(() => {
              submitBtn.classList.remove('is-success');
              submitBtn.innerHTML = originalBtnText;
              submitBtn.disabled = false;
            }, 3500);
            
          } catch (err) {
            console.error('🚨 Intake Form Telegram dispatch error:', err);
            status.style.color = 'var(--f-terracotta)';
            status.style.background = 'rgba(224, 90, 71, 0.08)';
            status.style.border = '1.5px solid var(--f-terracotta)';
            status.textContent = (err && err.message) 
              ? `TRANSMISSION FAILED: ${err.message}` 
              : 'TRANSMISSION FAILED. PLEASE REACH DIRECTLY VIA EMAIL OR RETRY.';
            
            // Re-enable button on failure since Turnstile token is still valid (or they can solve again if it timed out)
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalBtnText;
          } finally {
            // Button is re-enabled in catch or timeout
          }
        });
      }
    });
  